import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";
import { useReactToPrint } from "react-to-print";
import { Company_ledger_table_print } from "./company_ledger_table_print";

const Company_ledger_table = ({ledger}) => {
    const printRef = useRef();
            
    const printFn = useReactToPrint({
        contentRef: printRef,
        documentTitle: "company_ledger",
        preserveAfterPrint: true,
        print: (printIframe) =>
        new Promise(() => {
            printIframe.style.display = "none";
            printIframe.contentWindow?.print();
        }),
    });
    return (
        <div>
            <div
                style={{
                position: 'absolute',
                left: '-99999px',
                top: 0
                }}
            >
                <Company_ledger_table_print ref={printRef} ledger={ledger} />
            </div>
            {/* Expense List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی هاموو کردارەکانی کۆمپانیا</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            جۆری چالاکی
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            ژمارە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕ
                        </th>
                        {/* <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕی واسڵکراو
                        </th> */}
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                            بڕی قەرز
                        </th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {(() => {
                        let remained = 0;
                        return ledger?.map((lis, index) => {
                            var amount = Number(lis.total_amount) || 0;

                            if (lis.action_type === "init_loan") {
                            remained += amount;
                            } else if (lis.action_type === "loan_out") {
                            remained -= amount;
                            } else {
                            // assume sells that were loans increase the remained loan
                            if (lis.company_invoice_type === "loan") {
                                remained += amount;
                            }
                            }

                            return (
                            <tr key={index} className="hover:bg-slate-50 transition-colors duration-100">
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                        {lis.action_type === "init_loan"
                                        ? "قەرزی بنچینەیی"
                                        : lis.action_type === "loan_out"
                                        ? "قەرزی دراوە"
                                        : "کڕین" + (lis.company_invoice_type === "loan" ? " (قەرز)" : " (کاش)")}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.action_type === "init_loan"
                                    ? "-"
                                    : moment(lis.ledger_date).format("YYYY-MM-DD hh:mm A")}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis.action_type === "init_loan" ? "-" : lis.ledger_id}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(lis.total_amount))} $
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(money_rounding(remained))} $
                                </td>
                            </tr>
                            );
                        });
                        })()}
                    </tbody>
                </table>
            </div>
            <div className="mt-5 w-full">
                <button
                    className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-3 px-4 rounded h-12 w-full"
                    onClick={() => {
                        printFn();
                    }}
                >
                پرینت
                </button>
            </div>
        </div>
    )
}

export default Company_ledger_table